var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tutorial)?_c('Lesson',{attrs:{"isResources":true,"tutorialId":_vm.tutorial && _vm.tutorial.tutorialId,"resources":_vm.tutorial && _vm.tutorial.resources,"project":_vm.tutorial.project.id}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }